import axios from 'axios';
import { apiUrl, execUrl } from 'libs/commonVar';
import * as common from 'libs/commonFunc';

export const getShare = params => common.requestRaw(apiUrl + 'Share', params, 'get');
export const addShareUser = params => common.requestRaw(apiUrl + 'Share/AddUser', params, 'post');
export const cancelShareUser = params => common.requestRaw(apiUrl + 'Share/CancelUser', params, 'delete');
export const cancelShareService = params => common.requestRaw(apiUrl + 'Share/CancelService', params, 'delete');
// 아래 changeShareService 는 exec 로 구현해야 할듯
export const changeShareService = params => common.requestRaw(apiUrl + 'Share/ChangeService', params, 'post');



// WEBPACK FOOTER //
// ./src/script/libs/shareLib.js